//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Validate.js";
import "../no/Builder.js";
import "../Features/Features.GeometricConstraintDataManager.js";
import "../Validate/Validate.SelectionAndPlacementBuilder.js";
import "../no/Expression.js";
import "../no/Expression.js";
import "../no/Features.js";
let d=[[[0,"AboveLimit",0,0],[0,"AboveTarget",0,0],[0,"AutomaticUpdate",1,0],[0,"Average",0,0],[0,"BelowLimit",0,0],[0,"BelowTarget",0,0],[0,"ColorMapDisplayOptionType",1,0],[1,"GeometricConstraintDataManager",0,"Features.GeometricConstraintDataManager",0],[0,"Maximum",0,0],[0,"MaximumPorosity",1,0],[0,"Median",0,0],[0,"Minimum",0,0],[0,"MinimumPorosity",1,0],[0,"PreviewState",1,0],[1,"SelectionAndPlacement",0,"Validate.SelectionAndPlacementBuilder",0],[0,"TargetPorosity",1,0],[1,"VoxelSize",0,"Expression",0],[0,"WithinLimit",0,0]],[[[],"RemoveColorLegend",{},0,0],[[],"MakeColorLegend",{},0,0],[["face","point"],"AddGeometricConstraintPoint",{},2,0],[["face","point"],"SetGeometricConstraintPoint",{},2,0],[["point"],"DeleteGeometricConstraintPoint",{},1,0],[[],"ClearGeometricConstraintPoints",{},0,0]],[]];
SPLM.Validate.CheckPorosityBuilder = class extends SPLM.Builder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Validate.CheckPorosityBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.Validate.CheckPorosityBuilder.ColorMapDisplayOptionTypes = Object.freeze({
    "All" : "All", "WithinLimits" : "WithinLimits", "OutsideLimits" : "OutsideLimits", "AboveTarget" : "AboveTarget", "BelowTarget" : "BelowTarget"});

export default SPLM;